import type {UrlParamTypes} from "@songfinch/types";

export const buildShareableUrl = (urlParams: UrlParamTypes) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    Object.entries(urlParams).forEach(([key, value]) => {
        params.set(key, value);
    });

    url.search = params.toString();
    return url.href;
};